import React from "react"
import { connect } from "react-redux"
import uniqBy from "lodash.uniqby"
import PropTypes from "prop-types"
import { can, MODIFY_USERS_AND_ROLES } from "@src/helpers/authorization"
import TourTip from "@components/tour/tip"
import Modal from "./modal/"

const Icon = ({ shift = false, muted = false, children }) => 
  <div 
    style={{
      backgroundColor: muted ? '#f5f5f5' : '#faeaed',
      borderRadius: '100%',
      height: '32px',
      width: '32px',
      padding: '4px',
      fontWeight: '600',
      fontSize: '12px',
      border: `2px solid ${muted ? '#ddd' : '#ffccd5'}`,
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: shift ? '-6px' : '0px',
      flexShrink: 0
    }}>
    {children}
  </div>

const TeamAccess = ({
  visible,
  iconOnly = false,
  label = 'Team access',
  attachedUsers = [],
  roleUsers = [],
  parentUsers = [],
  ...props
}) => {
  const [showManageModal, setShowManageModal] = React.useState(false)
  if (!visible) {
    return null
  }
  const allMembers = uniqBy([...attachedUsers, ...roleUsers, ...parentUsers], user => user._id)
  return (
    <TourTip tipId='project_members'>
      {iconOnly ? 
        <button className='flex items-center cs-button link tooltip pointer ml1' data-tooltip={'Manage access'} data-placement='right' onClick={() => setShowManageModal(true)}>
          <div className='material-icons' style={{ fontSize: '20px', color: '#fb0f3b' }}>groups</div>
        </button>
        : <button className='flex items-center pl3 py1 cs-button link tooltip pointer' data-tooltip={'Manage access'} data-placement='right' onClick={() => setShowManageModal(true)}>
          <small className='mr1 bold'>{label}: </small>
          <div className='flex items-center'>
            {/* Up to 12 members, show initials in circles and stack them a bit */}
            {allMembers.slice(0, 12).map((user, i) => <Icon shift={i !== 0} key={user._id}>{getInitials(user.full_name)}</Icon>)}
          </div>
          {allMembers.length > 12 && <Icon shift>+{allMembers.length - 12}</Icon>}
          {/* Add icon */}
          <Icon shift muted><div className='material-icons' style={{ fontSize: '20px' }}>add</div></Icon>
        </button>
      }
      {showManageModal &&
        <Modal
          label={label}
          onClose={() => setShowManageModal(false)}
          attachedUserIDs={attachedUsers.map(u => u._id)}
          roleUsers={roleUsers}
          parentUsers={parentUsers}
          {...props}
        />}
    </TourTip>
  )
}

const getInitials = name => {
  const split = name.split(" ")
  return split[0].charAt(0) + (typeof split[1] === "string" ? split[1].charAt(0) : "")
}

TeamAccess.propTypes = {
  visible: PropTypes.bool.isRequired,
  label: PropTypes.string,
  attachedUsers: PropTypes.array,
  roleUsers: PropTypes.array,
  parentUsers: PropTypes.array,
  canEditAccess: PropTypes.bool.isRequired
}

const mapStateToProps = state => ({
  visible: state.user.auth.organization_id !== null,
  canEditAccess: can(state.user.auth, [MODIFY_USERS_AND_ROLES])
})

export default connect(mapStateToProps)(TeamAccess)